import { z } from "zod";

import { fillTemplate } from "../values/fill-template";
import { MAX_STORED_FILE_BYTES } from "./document-slots";
import copyJson from "./documents-copy.json";

const text = z.string().min(1);

const copySchema = z.object({
  pdfFileValidation: z.object({ invalid_extension: text, invalid_mime_type: text, file_too_large: text }),
  slot: z.object({
    documentNotFound: text,
    invalidDocumentType: text,
    pdfFileRequired: text,
    fileUnreadable: text,
    uploadFailed: text,
    replacementReasonWithoutReplacement: text,
    versionNotFound: text,
    invalidContextDocumentType: text,
    unknownBatchDocumentType: text,
  }),
  storage: z.object({ downloadFailed: text, signedUrlFailed: text }),
  catalog: z.object({
    unsafeKey: text,
    duplicateKey: text,
    noApplicableContext: text,
    invalidOrder: text,
    duplicateOrder: text,
  }),
  typeLabels: z.object({
    certificate_of_analysis: text,
    specification: text,
    supplier_coa: text,
    gc: text,
    nmr: text,
    hplc: text,
    ir: text,
    msds: text,
    product_origin: text,
    quote: text,
    correspondence: text,
    poDocument: text,
    invoice: text,
    coa: text,
    shippingDocument: text,
    creditMemo: text,
    countryOfOrigin: text,
    miscellaneous: text,
    packingSlip: text,
    releaseOrder: text,
  }),
  typeShortLabels: z.object({ specification: text, product_origin: text }),
});

const copy = copySchema.parse(copyJson);

export const PDF_FILE_VALIDATION_COPY = {
  ...copy.pdfFileValidation,
  file_too_large: fillTemplate(copy.pdfFileValidation.file_too_large, { megabytes: MAX_STORED_FILE_BYTES / (1024 * 1024) }),
};
export const DOCUMENT_SLOT_MESSAGES = copy.slot;
export const DOCUMENT_STORAGE_MESSAGES = copy.storage;
export const DOCUMENT_TYPE_LABELS = copy.typeLabels;
export const DOCUMENT_TYPE_SHORT_LABELS = copy.typeShortLabels;

export function invalidContextDocumentTypeMessage(context: string, documentType: string): string {
  return fillTemplate(copy.slot.invalidContextDocumentType, { context, documentType });
}

export function unknownBatchDocumentTypeMessage(documentType: string): string {
  return fillTemplate(copy.slot.unknownBatchDocumentType, { documentType });
}

export function unsafeDocumentKeyMessage(key: string): string {
  return fillTemplate(copy.catalog.unsafeKey, { key });
}

export function duplicateDocumentKeyMessage(key: string): string {
  return fillTemplate(copy.catalog.duplicateKey, { key });
}

export function noApplicableContextMessage(key: string): string {
  return fillTemplate(copy.catalog.noApplicableContext, { key });
}

export function invalidContextOrderMessage(context: string, key: string): string {
  return fillTemplate(copy.catalog.invalidOrder, { context, key });
}

export function duplicateContextOrderMessage(context: string, position: number): string {
  return fillTemplate(copy.catalog.duplicateOrder, { context, position });
}
